const supportPageOffset = window.pageXOffset !== undefined;
const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

function getPositionX() {
    return (
        supportPageOffset ? window.pageXOffset : isCSS1Compat //eslint-disable-line
            ? document.documentElement.scrollLeft : document.body.scrollLeft
    );
}

function getPositionY() {
    return (
        supportPageOffset ? window.pageYOffset : isCSS1Compat //eslint-disable-line
            ? document.documentElement.scrollTop : document.body.scrollTop
    );
}

export default function initFixedNavBar(selector) {
    const navbarContainer = document.querySelector(selector);
    if (!navbarContainer) {
        // Not on page, ex. dashboard/catalogue
        return;
    }
    const startPosition = navbarContainer.offsetHeight;
    window.addEventListener('scroll', () => {
        const posY = getPositionY();
        const posX = `-${getPositionX()}px`;
        let ticking = false;
        if (!ticking) {
            window.requestAnimationFrame(() => {
                if (posY >= startPosition) {
                    const fixedNavbar = document.getElementsByClassName('navbar-default')[0];
                    fixedNavbar.classList.add('visible');
                    fixedNavbar.style.left = posX;
                } else {
                    const fixedNavbar = document.getElementsByClassName('navbar-default')[0];
                    fixedNavbar.classList.remove('visible');
                    fixedNavbar.style.left = posX;
                }
                ticking = false;
            });
        }
        ticking = true;
    });
}



// WEBPACK FOOTER //
// ./src/utils/fixedNavBar.js